import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_cremation_details, save_cremation_details } from './api';
import type { CremationDetailsRequest } from './types';

const KEY = ['module-details', 'cremation'] as const;

export function use_save_cremation_details() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CremationDetailsRequest) => save_cremation_details(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['onboarding', 'draft'] });
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function use_cremation_details(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY,
    queryFn: fetch_cremation_details,
    staleTime: 0,
    retry: 0,
    enabled: options?.enabled ?? true,
  });
}
